<template>
    <div>
        <div class="card" v-if="pageWidth>1000">
            <div>
                <!-- 简介 -->
                <div style="overflow: hidden">
                    <div class="text animate__animated animate__fadeInLeft">
                        <p class="title">05 <span>多模认知通讯系统</span></p>
                        <!--            <p style="text-indent: 2em;">-->
                        <!--              近年来，随着无人机技术的快速发展和应用场景的不断拓展，低空经济无人机作为一种创新的航空工具，正逐渐成为各行各业的热门选择。低空经济无人机指的是那些能够在低空区域（通常指离地面100米以下）进行飞行和任务执行的无人机。-->
                        <!--              低空经济无人机应用广泛的背景主要包括以下几个方面：-->
                        <!--              物流与运输、农业与农村发展、建筑与工程、环境保护与资源管理、媒体与娱乐、紧急救援等。-->
                        <!--            </p>-->
                        <!--            <p style="text-indent: 2em;">-->
                        <!--              当无人机涉及多场景作业时，不同场景中5G网络覆盖程度的不确定性和复杂电磁环境中突发干扰均会影响空地通信质量，具体面临以下两个难题：一是在5G网络弱覆盖或未覆盖区域出现通信质量降低甚至通信中断；二是空地通信链路在城市场景中易受突发性电磁干扰。如何实现5G网络和自组网链路间的智能切换，以及在复杂电磁环境干扰下保证通信链路的质量，实现机载双模认知通信是亟需解决的关键技术难题之一。</p>-->
                        <p style="text-indent: 2em;">
                            多模认知通信系统旨在构建一个智能、高效、可靠的通信基础设施，以支持多台无人机之间的协同作业。该系统包括小型专网传输模块、5G公网通信模块、主控单元和通信协调软件等核心组件。通过整合这些模块，系统能够实现无人机在自组网通信和公网通信之间的智能切换，确保通信的连续性、高效性及可靠性。主控单元上部署的通信协调软件负责监测网络态势、进行信令转发，并支持可视化展示和跨平台移植，为用户提供全面的通信管理和监控能力。</p>

                    </div>
                    <div class="image animate__animated animate__fadeInRight">
                        <img src="../../../assets/solution/yunhe/communication.png" alt="">
                    </div>
                </div>
                <!-- 系统组成&&技术要点  -->
                <div class="compose text">
                    <div class="peculiarity animate__animated animate__fadeInLeft">
                        <h3 class="title"><span>系统组成</span></h3>
                        <p style="margin-bottom: 20px">
                            双模认知通信组件由专网自组网模块、5G网联模块、频谱感知模块、认知通信计算单元组成。主要设计自组网、5G网联、智能切换等三种工作模式：</p>
                        <div>
                            <h4>自组网模式</h4>
                            <p>
                                通过轻小型自组网通信传输模块实现无人机之间的本地网络组建，适用于局部区域通信，无需依赖外部基础设施，提供低延迟和稳定的通信服务，但通信范围受限。</p>
                        </div>
                        <div>
                            <h4>5G网联模式</h4>
                            <p>利用5G网联通信模块实现与远程服务器或其他无人机的全球范围通信，支持大规模数据传输和远程控制，适用于远距离任务执行和全球性协同作业，但需要通信网络基础设施。
                            </p>
                        </div>
                        <div>
                            <h4>智能切换模式</h4>
                            <p>
                                认知通信计算单元根据频谱感知模块、自组网模块、5G网联模块的感知信息，智能选择自组网与5G网络，可以自适应不同任务和环境需求。最大程度地优化通信性能和资源利用效率。</p>
                        </div>
                        <h3 class="title"><span>技术要点</span></h3>
                        <div>
                            <h4>智能网络切换</h4>
                            <p>无人大脑可以智能地在5G公网和专网自组网之间进行网络切换，以保证通信的稳定性和效率。</p>
                        </div>
                        <div>
                            <h4>频点智能决策</h4>
                            <p>无人大脑能够智能地决定专网自组网通信频点，以确保通信质量和安全性。</p>
                        </div>
                        <div>
                            <h4>网联飞行与控制</h4>
                            <p>这项技术能够兼容无人机在空中与地面控制中心之间的通信，实现更加高效和可靠的飞行管理。</p>
                        </div>
                        <div>
                            <h4>高可靠通信</h4>
                            <p>通过以上功能的实现，保证了无人机在各种网络环境下的通信高可靠性。</p>
                        </div>

                    </div>

                </div>

<!--                &lt;!&ndash; 关键指标  &ndash;&gt;-->
<!--                <div class="text text2  animate__animated animate__fadeInLeft">-->
<!--                    <h3 class="title"><span>关键指标</span></h3>-->
<!--                    <div class="keyMetrics">-->
<!--                        <div>-->
<!--                            <h4>1.功能指标</h4>-->
<!--                            <table>-->
<!--                                <thead>-->
<!--                                <tr>-->
<!--                                    <th>序号</th>-->
<!--                                    <th>详细功能指标</th>-->
<!--                                </tr>-->
<!--                                </thead>-->
<!--                                <tbody>-->
<!--                                <tr>-->
<!--                                    <td>1</td>-->
<!--                                    <td class="mark">具备公网和专网的通信性能评估能力，优先选用低时延通道</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>2</td>-->
<!--                                    <td class="mark">具备增加节点重新配置能力，支持动态加入/退出组网</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>3</td>-->
<!--                                    <td>支持的自组网状态：公网、专网、公网与专网融合</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>4</td>-->
<!--                                    <td>专网具备mesh自组网能力</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>5</td>-->
<!--                                    <td>具备公网状态监测能力</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>6</td>-->
<!--                                    <td>具备点到点可靠通信能力</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>7</td>-->
<!--                                    <td>提供硬件接口：网口、串口，其中网口用于和其他机载设备进行通信，串口用于与飞控模块进行数据交互</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>8</td>-->
<!--                                    <td>通信协调软件可跨平台移植，支持TX2</td>-->
<!--                                </tr>-->
<!--                                </tbody>-->
<!--                            </table>-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            <h4>2.性能指标</h4>-->
<!--                            <table>-->
<!--                                <thead>-->
<!--                                <tr>-->
<!--                                    <th>序号</th>-->
<!--                                    <th>指标项</th>-->
<!--                                    <th>详细性能指标</th>-->
<!--                                </tr>-->
<!--                                </thead>-->
<!--                                <tbody>-->
<!--                                <tr>-->
<!--                                    <td>1</td>-->
<!--                                    <td class="mark">网络态势感知速率</td>-->
<!--                                    <td class="mark">≥2次/s</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>2</td>-->
<!--                                    <td>网络接入时间</td>-->
<!--                                    <td>＜50ms</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>3</td>-->
<!--                                    <td>在节点分布约10km直径范围、0-500m高度范围内、节点移动速度0-40m/s场景下，任意两个节点-->
<!--                                        <br/>-->
<!--                                        通信延迟-->
<!--                                    </td>-->
<!--                                    <td>≤50ms</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>4</td>-->
<!--                                    <td>通视距离≥5km，通信距离不超过10km条件下（山地场景）-->
<!--                                        <br/>-->
<!--                                        通信带宽-->
<!--                                    </td>-->
<!--                                    <td>≥1Mbps</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>5</td>-->
<!--                                    <td>通视距离≥5km，通信距离不超过10km条件下（山地场景-->
<!--                                        <br/>-->
<!--                                        数据传输速率-->
<!--                                    </td>-->
<!--                                    <td>≥20Mbps-->
<!--                                    </td>-->
<!--                                </tr>-->
<!--                                </tbody>-->
<!--                            </table>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <!-- 应用场景  -->
                <div class="text text2 animate__animated animate__fadeInLeft">
                    <h3 class="title"><span>应用场景</span></h3>
                    <div class="scenario_box">
                        <div style="width: 629px;float: left">
                            <h4>紧急救援</h4>
                            <p>
                                在紧急救援中，无人机可以通过多模认知通讯系统来实现对周围的无线环境的感知和了解。这种技术可以帮助无人机快速找到空闲的频段，并对通信链接进行优化，以便在紧急情况下实现高效的救援任务。此外，多模认知通讯系统还可以帮助无人机自主地选择最佳的通信频段，并根据环境的变化调整通信行为，以便在复杂的通信环境中保持通信的稳定性和可靠性。通过这种方式，无人机可以为救援人员提供及时、准确的信息支持，帮助他们更好地完成救援任务。</p>
                        </div>
                        <div class="animate__animated animate__fadeInRight">
                            <img src="../../../assets/solution/yunhe/scenario1.png" alt="">
                        </div>
                    </div>

                    <div class="scenario_box">
                        <div style="width: 629px;float: left">
                            <h4>农业领域</h4>
                            <p>
                                在农业领域，无人机可以利用多模认知通讯系统实现精准的农业作业。无人机可以搭载各种类型的传感器，例如气象传感器和光谱传感器等，以便在飞行过程中对农田进行巡查和监测。通过对周围的无线环境的感知和了解，无人机可以自主地选择最佳的通信频段，并根据环境的变化调整通信行为。在农业作业过程中，无人机可以利用多模认知通讯系统实现与农业管理系统的高效通信，并将所采集的数据反馈给农业管理系统，以便进行更加精准的农业管理和决策。</p>
                        </div>
                        <div class="animate__animated animate__fadeInRight">
                            <img src="../../../assets/solution/yunhe/scenario2.png" alt="">
                        </div>
                    </div>


                    <div class="scenario_box">
                        <div style="width: 629px;float: left">
                            <h4>城市交通监控</h4>
                            <p>
                                在城市交通监控中，无人机可以通过多模认知通讯系统实现对城市交通状况的及时监测和反馈。无人机可以搭载各类传感器和摄像头，以便在飞行过程中对交通状况进行监测和分析。通过对周围的无线环境的感知和了解，无人机可以自主地选择最佳的通信频段，并将所采集的数据反馈给交通管理系统，以便实现对城市交通的动态监测和管理。此外，多模认知通讯系统还可以帮助无人机实现与交通管理系统的高效通信，以确保信息传输的稳定性和可靠性。</p>
                        </div>
                        <div class="animate__animated animate__fadeInRight">
                            <img src="../../../assets/solution/yunhe/scenario3.png" alt="">
                        </div>
                    </div>

                    <div class="scenario_box">
                        <div style="width: 629px;float: left">
                            <h4>环境监测</h4>
                            <p>
                                在环境监测中，无人机可以利用多模认知通讯系统实现对环境的高效监测和数据采集。无人机可以搭载各种类型的传感器和监测仪器，例如气象传感器和多光谱传感器等，以便在飞行过程中对环境进行监测和分析。通过对周围的无线环境的感知和了解，无人机可以自主地选择最佳的通信频段，并将所采集的数据反馈给环境管理系统，以便进行更加精准的环境管理和决策。</p>
                        </div>
                        <div class="animate__animated animate__fadeInRight">
                            <img src="../../../assets/solution/yunhe/scenario4.png" alt="">
                        </div>
                    </div>

                    <div class="scenario_box">
                        <div style="width: 629px;">
                            <h4>电力巡检</h4>
                            <p>
                                在电力巡检中，无人机可以利用多模认知通讯系统实现对电力设施的快速巡检和故障排除。无人机可以搭载各种类型的传感器和摄像头，以便在飞行过程中对电力设施进行监测和分析。通过对周围的无线环境的感知和了解，无人机可以自主地选择最佳的通信频段，并将所采集的数据反馈给电力管理系统，以便实现对电力设施的动态监测和管理。此外，多模认知通讯系统还可以帮助无人机实现与电力管理系统的高效通信，以确保信息传输的稳定性和可靠性。</p>
                        </div>
                        <div class="animate__animated animate__fadeInRight">
                            <img src="../../../assets/solution/yunhe/scenario5.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" v-else>
            <div>
                <div class="text animate__animated animate__fadeInLeft">
                    <h2 class="title">05 <span>多模认知通讯系统</span></h2>
                    <!--          <p style="text-indent: 2em;">-->
                    <!--            近年来，随着无人机技术的快速发展和应用场景的不断拓展，低空经济无人机作为一种创新的航空工具，正逐渐成为各行各业的热门选择。低空经济无人机指的是那些能够在低空区域（通常指离地面100米以下）进行飞行和任务执行的无人机。-->
                    <!--            低空经济无人机应用广泛的背景主要包括以下几个方面：-->
                    <!--            物流与运输、农业与农村发展、建筑与工程、环境保护与资源管理、媒体与娱乐、紧急救援等。-->
                    <!--          </p>-->
                    <!--          <p style="text-indent: 2em;">-->
                    <!--            当无人机涉及多场景作业时，不同场景中5G网络覆盖程度的不确定性和复杂电磁环境中突发干扰均会影响空地通信质量，具体面临以下两个难题：一是在5G网络弱覆盖或未覆盖区域出现通信质量降低甚至通信中断；二是空地通信链路在城市场景中易受突发性电磁干扰。如何实现5G网络和自组网链路间的智能切换，以及在复杂电磁环境干扰下保证通信链路的质量，实现机载双模认知通信是亟需解决的关键技术难题之一。-->
                    <!--          </p>-->
                    <p style="text-indent: 2em;">
                        多模认知通信系统旨在构建一个智能、高效、可靠的通信基础设施，以支持多台无人机之间的协同作业。该系统包括小型专网传输模块、5G公网通信模块、主控单元和通信协调软件等核心组件。通过整合这些模块，系统能够实现无人机在自组网通信和公网通信之间的智能切换，确保通信的连续性、高效性及可靠性。主控单元上部署的通信协调软件负责监测网络态势、进行信令转发，并支持可视化展示和跨平台移植，为用户提供全面的通信管理和监控能力。</p>
                    <div class="image animate__animated animate__fadeInRight">
                        <img src="../../../assets/solution/yunhe/communication.png" alt="">
                    </div>
                    <div class="peculiarity">
                        <h3 class="title"><span>系统组成</span></h3>
                        <p style="margin-bottom: 20px">
                            双模认知通信组件由专网自组网模块、5G网联模块、频谱感知模块、认知通信计算单元组成。主要设计自组网、5G网联、智能切换等三种工作模式：</p>
                        <div>
                            <h4>自组网模式</h4>
                            <p>
                                通过轻小型自组网通信传输模块实现无人机之间的本地网络组建，适用于局部区域通信，无需依赖外部基础设施，提供低延迟和稳定的通信服务，但通信范围受限。</p>
                        </div>
                        <div>
                            <h4>5G网联模式</h4>
                            <p>利用5G网联通信模块实现与远程服务器或其他无人机的全球范围通信，支持大规模数据传输和远程控制，适用于远距离任务执行和全球性协同作业，但需要通信网络基础设施。
                            </p>
                        </div>
                        <div>
                            <h4>智能切换模式</h4>
                            <p>
                                认知通信计算单元根据频谱感知模块、自组网模块、5G网联模块的感知信息，智能选择自组网与5G网络，可以自适应不同任务和环境需求。最大程度地优化通信性能和资源利用效率。</p>
                        </div>


                        <h3 class="title"><span>技术要点</span></h3>
                        <div>
                            <h4>智能网络切换</h4>
                            <p>无人大脑可以智能地在5G公网和专网自组网之间进行网络切换，以保证通信的稳定性和效率。</p>
                        </div>
                        <div>
                            <h4>频点智能决策</h4>
                            <p>无人大脑能够智能地决定专网自组网通信频点，以确保通信质量和安全性。</p>
                        </div>
                        <div>
                            <h4>网联飞行与控制</h4>
                            <p>这项技术能够兼容无人机在空中与地面控制中心之间的通信，实现更加高效和可靠的飞行管理。</p>
                        </div>
                        <div>
                            <h4>高可靠通信</h4>
                            <p>通过以上功能的实现，保证了无人机在各种网络环境下的通信高可靠性。</p>
                        </div>

<!--                        <h3 class="title"><span>关键指标</span></h3>-->
<!--                        <div class="keyMetrics">-->
<!--                            <div>-->
<!--                                <h4>1.功能指标</h4>-->
<!--                                <table>-->
<!--                                    <thead>-->
<!--                                    <tr>-->
<!--                                        <th>序号</th>-->
<!--                                        <th>详细功能指标</th>-->
<!--                                    </tr>-->
<!--                                    </thead>-->
<!--                                    <tbody>-->
<!--                                    <tr>-->
<!--                                        <td>1</td>-->
<!--                                        <td class="mark">具备公网和专网的通信性能评估能力，优先选用低时延通道</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>2</td>-->
<!--                                        <td class="mark">具备增加节点重新配置能力，支持动态加入/退出组网</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>3</td>-->
<!--                                        <td>支持的自组网状态：公网、专网、公网与专网融合</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>4</td>-->
<!--                                        <td>专网具备mesh自组网能力</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>5</td>-->
<!--                                        <td>具备公网状态监测能力</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>6</td>-->
<!--                                        <td>具备点到点可靠通信能力</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>7</td>-->
<!--                                        <td>提供硬件接口：网口、串口，其中网口用于和其他机载设备进行通信，串口用于与飞控模块进行数据交互</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>8</td>-->
<!--                                        <td>通信协调软件可跨平台移植，支持TX2</td>-->
<!--                                    </tr>-->
<!--                                    </tbody>-->
<!--                                </table>-->
<!--                            </div>-->
<!--                            <div>-->
<!--                                <h4>2.性能指标</h4>-->
<!--                                <table>-->
<!--                                    <thead>-->
<!--                                    <tr>-->
<!--                                        <th>序号</th>-->
<!--                                        <th>指标项</th>-->
<!--                                        <th>详细性能指标</th>-->
<!--                                    </tr>-->
<!--                                    </thead>-->
<!--                                    <tbody>-->
<!--                                    <tr>-->
<!--                                        <td>1</td>-->
<!--                                        <td class="mark">网络态势感知速率</td>-->
<!--                                        <td class="mark">≥2次/s</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>2</td>-->
<!--                                        <td>网络接入时间</td>-->
<!--                                        <td>＜50ms</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>3</td>-->
<!--                                        <td>在节点分布约10km直径范围、0-500m高度范围内、节点移动速度0-40m/s场景下，任意两个节点-->
<!--                                            <br/>-->
<!--                                            通信延迟-->
<!--                                        </td>-->
<!--                                        <td>≤50ms</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>4</td>-->
<!--                                        <td>通视距离≥5km，通信距离不超过10km条件下（山地场景）-->
<!--                                            <br/>-->
<!--                                            通信带宽-->
<!--                                        </td>-->
<!--                                        <td>≥1Mbps</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>5</td>-->
<!--                                        <td>通视距离≥5km，通信距离不超过10km条件下（山地场景-->
<!--                                            <br/>-->
<!--                                            数据传输速率-->
<!--                                        </td>-->
<!--                                        <td>≥20Mbps-->
<!--                                        </td>-->
<!--                                    </tr>-->
<!--                                    </tbody>-->
<!--                                </table>-->
<!--                            </div>-->
<!--                        </div>-->
                        <h3 class="title"><span>应用场景</span></h3>
                        <div>
                            <h4>紧急救援</h4>
                            <p>
                                在紧急救援中，无人机可以通过多模认知通讯系统来实现对周围的无线环境的感知和了解。这种技术可以帮助无人机快速找到空闲的频段，并对通信链接进行优化，以便在紧急情况下实现高效的救援任务。此外，多模认知通讯系统还可以帮助无人机自主地选择最佳的通信频段，并根据环境的变化调整通信行为，以便在复杂的通信环境中保持通信的稳定性和可靠性。通过这种方式，无人机可以为救援人员提供及时、准确的信息支持，帮助他们更好地完成救援任务。</p>
                            <img src="../../../assets/solution/yunhe/scenario1.png" alt="" style="margin-top: 10px">
                        </div>
                        <div>
                            <h4>农业领域</h4>
                            <p>
                                在农业领域，无人机可以利用多模认知通讯系统实现精准的农业作业。无人机可以搭载各种类型的传感器，例如气象传感器和光谱传感器等，以便在飞行过程中对农田进行巡查和监测。通过对周围的无线环境的感知和了解，无人机可以自主地选择最佳的通信频段，并根据环境的变化调整通信行为。在农业作业过程中，无人机可以利用多模认知通讯系统实现与农业管理系统的高效通信，并将所采集的数据反馈给农业管理系统，以便进行更加精准的农业管理和决策。</p>
                            <img src="../../../assets/solution/yunhe/scenario2.png" alt="" style="margin-top: 10px">
                        </div>
                        <div>
                            <h4>城市交通监控</h4>
                            <p>
                                在城市交通监控中，无人机可以通过多模认知通讯系统实现对城市交通状况的及时监测和反馈。无人机可以搭载各类传感器和摄像头，以便在飞行过程中对交通状况进行监测和分析。通过对周围的无线环境的感知和了解，无人机可以自主地选择最佳的通信频段，并将所采集的数据反馈给交通管理系统，以便实现对城市交通的动态监测和管理。此外，多模认知通讯系统还可以帮助无人机实现与交通管理系统的高效通信，以确保信息传输的稳定性和可靠性。</p>
                            <img src="../../../assets/solution/yunhe/scenario3.png" alt="" style="margin-top: 10px">
                        </div>


                        <div>
                            <h4>环境监测</h4>
                            <p>
                                在环境监测中，无人机可以利用多模认知通讯系统实现对环境的高效监测和数据采集。无人机可以搭载各种类型的传感器和监测仪器，例如气象传感器和多光谱传感器等，以便在飞行过程中对环境进行监测和分析。通过对周围的无线环境的感知和了解，无人机可以自主地选择最佳的通信频段，并将所采集的数据反馈给环境管理系统，以便进行更加精准的环境管理和决策。</p>
                            <img src="../../../assets/solution/yunhe/scenario4.png" alt="" style="margin-top: 10px">
                        </div>

                        <div>
                            <h4>电力巡检</h4>
                            <p>
                                在电力巡检中，无人机可以利用多模认知通讯系统实现对电力设施的快速巡检和故障排除。无人机可以搭载各种类型的传感器和摄像头，以便在飞行过程中对电力设施进行监测和分析。通过对周围的无线环境的感知和了解，无人机可以自主地选择最佳的通信频段，并将所采集的数据反馈给电力管理系统，以便实现对电力设施的动态监测和管理。此外，多模认知通讯系统还可以帮助无人机实现与电力管理系统的高效通信，以确保信息传输的稳定性和可靠性。</p>
                            <img src="../../../assets/solution/yunhe/scenario5.png" alt="" style="margin-top: 10px">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pageWidth: window.innerWidth
        }
    },
    mounted() {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.pageWidth = window.innerWidth;
        }
    }
}
</script>

<style scoped lang="less">
@import "../../../styles/spectrum/dualModeCognition";
</style>
